import React from "react";

export default function Devops() {
  return (
    <>
      <div className="hm1 pt-40">
        <div className="lg:text-7xl py-8 pt-10 font-bold text-white text-center">
          <p className="pt-10">DevOps Consulting Services </p>
          <p className="pt-2">and Solutions Company</p>
          <div className="flex justify-center">
            <img src="https://mkt-cdn.dynatrace.com/assets/Marketing/content-images/devops-cycle.png?_ga=2.241633922.1662464413.1686975378-1284567366.1686975378&_gac=1.16056834.1686978106.EAIaIQobChMI5drzwLnJ_wIVBxtyCh1KqwDqEAAYASAAEgJilPD_BwE" />
          </div>{" "}
        </div>
      </div>
      <div className="lg:pt-32 py-8 ">
        <p className="lg:text-5xl text-center font-bold">
          Accelerating Software Delivery with DevOps{" "}
        </p>
        <p className="lg:text-5xl text-center font-bold pt-5">Services</p>
        <div className="text-center lg:text-2xl pt-20 text-gray-700">
          <p className="px-5">
            With DevOps Competency and Center of Excellence, We enable
            organisations with DevOps services{" "}
          </p>
          <p>
            and solutions along GitOps for progressive and continuous Delivery,
            application modernisation and
          </p>
          <p>modern applications on Hybrid and On-premises environments.</p>
        </div>
        <section className="py-6 sm:py-12 a a">
          <div className="container p-6 mx-auto space-y-8">
            <div className="space-y-2 text-center">
              <h2 className="text-3xl font-bold text-white">
                Enhance DevOps Implementation with Agility{" "}
              </h2>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
              <article className="flex flex-col shadow-2xl bg-white b">
                <img
                  alt=""
                  className="object-cover w-full h-52 a"
                  src="https://t3.ftcdn.net/jpg/02/82/37/86/360_F_282378637_7DL904AvZkZovk3RqLdLwNe21RNcjpzg.jpg"
                />

                <div className="flex flex-col p-2">
                  <h3 className="flex-1 py-2 text-lg font-semibold leadi">
                    Cloud-Native Architecture and Development
                  </h3>
                  <p className="text-blue-700">
                    Empowering cloud-native capabilities for streamlining
                    continuous integration, development, automation, and agility
                    of developed applications.
                  </p>
                </div>
              </article>
              <article className="flex flex-col shadow-2xl bg-white b">
                <img
                  alt=""
                  className="object-cover w-full h-52 a"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUxl2zIkneq6PCgrgQN0qrc0h6g8zti-UG-A&usqp=CAU"
                />

                <div className="flex flex-col  p-2">
                  <h3 className="flex-1 py-2 text-lg font-semibold leadi">
                    Enterprise DevOps Framework
                  </h3>
                  <p className="text-blue-700">
                    Building architecture to reduce operational friction,
                    expedite application delivery, and stale operation
                    environment.
                  </p>
                </div>
              </article>
              <article className="flex shadow-2xl flex-col bg-white b">
                <img
                  alt=""
                  className="object-cover w-full h-52 a"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQB20AUT87YbkbVcIOv6KW1Blv_qJBb9OcUtw&usqp=CAU"
                />

                <div className="flex flex-col  p-2">
                  <h3 className="flex-1 py-2  text-lg font-semibold leadi">
                    Enabling Infrastructure Automation with Terraform
                  </h3>
                  <p className="text-blue-700">
                    Solutions for enabling automated workflow provisioning, and
                    unified management of resources.
                  </p>
                </div>
              </article>
              <article className="flex flex-col shadow-2xl bg-white b">
                <img
                  alt=""
                  className="object-cover w-full h-52 a"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnunC5_AsoduiIjbj0dRSU-frX51OKv5nnzQ&usqp=CAU"
                />

                <div className="flex flex-col  p-2">
                  <h3 className="flex-1 py-2 text-lg font-semibold leadi">
                    Cloud-Native Architecture and Development
                  </h3>
                  <p className="text-blue-700">
                    Building AWS-based Applications with AWS CodePipeline, AWS
                    CodeBuild, and AWS CodeDeploy additionally automates the
                    processes between Software Development and the Operation
                    Teams.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </section>
        <div className=" bg-gray-400">
          <div className="flex px-5 lg:flex-row flex-col justify-center lg:gap-20">
            <div className="flex flex-col py-8">
              <p className="py-8 lg:text-5xl font-bold">
                DevOps Implementation <br />
                Services for Enterprises
              </p>
              <p className="text-2xl py-4">
                Accelerate your business workflow with automation,
                <br /> Implement monitoring practices and build <br />
                roadmap with streamlined Adoption Strategy
              </p>
              <p className="text-blue-800 lg:pt-10 font-bold lg:text-3xl">
                Enterprise Adoption Stratigies
              </p>
            </div>
            <img
              src="https://www.xenonstack.com/hubfs/xenonstack-devops-circle.svg"
              className="h-[500px]"
            />
          </div>
        </div>
        <div className="pt-32">
          <p className="lg:text-5xl text-center font-bold">
            DevOps Services with Value Stream{" "}
          </p>
          <p className="lg:text-5xl text-center font-bold pt-5">Management.</p>
          <div className="flex flex-col lg:flex-row border shadow-2xl px-5 py-5 lg:mx-48 mt-10 justify-center pt-20 gap-20">
            <div className="flex flex-col">
              <img
                src="https://www.xenonstack.com/hubfs/xenonstack-continuous-integration-and-deployment.svg"
                className="h-24 "
              />
              <p className="text-4xl font-bold pt-5">
                Scaling DevOps and Agility to Enterprise
              </p>
              <p className="text-xl pt-5">
                Enterprise Assessment for modernization, Release engineering,
                <br />
                infrastrucuture automation, continuous integration and
                deployment,
                <br /> continuous testing and automating Pipelines using Jenkins
                and Docker.
              </p>
              <p className="pt-10 text-blue-500 text-xl">
                How to Build and Deploy Effective CI/CD Pipeline
              </p>
            </div>
            <img
              src="	https://www.xenonstack.com/hubfs/xenonstack-continuous-integration-and-deployment-services.svg"
              className="h-96"
            />
          </div>
        </div>
      </div>
      <section className="py-6 sm:py-12 a a">
        <div className="container p-6 mx-auto space-y-8">
          <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
            <article className="flex flex-col shadow-2xl bg-white b">
              <img
                alt=""
                className=" h-52 a"
                src="	https://www.xenonstack.com/hubfs/xenonstack-continuous-delivery-solutions.svg"
              />

              <div className="flex flex-col p-2 px-5">
                <h3 className="flex-1 py-2 text-2xl font-bold ">
                  Continious Delivery - CI/CD
                </h3>
                <p className="text-gray-700 text-xl">
                  Enabling services with building pipelines on microservices,
                  Serverless Computing on Docker, Kubernetes, Hybrid, and Public
                  Cloud.
                </p>
              </div>
            </article>
            <article className="flex flex-col shadow-2xl bg-white b">
              <img
                alt=""
                className=" h-52 a"
                src="	https://www.xenonstack.com/hubfs/xenonstack-devops-strategy-and-advisory-services.svg"
              />

              <div className="flex flex-col p-2 px-5">
                <h3 className="flex-1 py-2 text-2xl font-bold ">
                  Enterprise Devops
                </h3>
                <p className="text-gray-700 text-xl">
                  Talk with our Specialists for assessment on Infrastructure
                  Automation, Continuous Integration, Continuous Deployment, and
                  Automation Strategy.
                </p>
              </div>
            </article>
            <article className="flex flex-col shadow-2xl bg-white b">
              <img
                alt=""
                className=" h-52 a"
                src="https://www.xenonstack.com/hubfs/xenonstack-devops-monitoring-solutions.svg"
              />

              <div className="flex flex-col p-2 px-5">
                <h3 className="flex-1 py-2 text-2xl font-bold ">
                  Observability
                </h3>
                <p className="text-gray-700 text-xl">
                  Monitoring Services for enabling the visibility of
                  Microservices applications and Pipeline with Docker and
                  Kubernetes.
                </p>
              </div>
            </article>
            <article className="flex flex-col shadow-2xl bg-white b">
              <img
                alt=""
                className=" h-52 a"
                src="	https://www.xenonstack.com/hubfs/xenonstack-devops-success-with-devops-metrics.svg"
              />

              <div className="flex flex-col p-2 px-5">
                <h3 className="flex-1 py-2 text-2xl font-bold ">
                  Devops Analytic
                </h3>
                <p className="text-gray-700 text-xl">
                  Explore the guide to metrics and Key Performance Indicators
                  (KPIs) and 15 metrics for measuring successful adoption for
                  enterprises.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>
      <p className="lg:text-5xl pt-32 text-center font-bold">
        How We Develop DevOps Capabilities?
      </p>
      <p className="text-2xl pt-10 text-gray-700 text-center">
        Implement and Execute end-to-end Streamlined Strategy
      </p>
      <section className="a pt-10 pb-10 a">
        <div className="container flex flex-col justify-center px-4 py-8 mx-auto md:p-8">
          <div className="space-y-4">
            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 font-bold lg:text-4xl  focus:outline-none focus-visible:ri">
                Overview of What is DevOps and it’s Processes??
              </summary>
              <p className="px-4 py-6 pt-10 ml-4 -mt-4 text-blue-500 text-xl ">
                Explore in detail about What is DevOps, Business Benefits of
                Adopting DevOps Processes and Best Automation Tools.{" "}
              </p>
            </details>
            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 font-bold lg:text-4xl focus:outline-none focus-visible:ri">
                Ten Best Practices for Enterprise Transformation?
              </summary>
              <p className="px-4 py-6 pt-10 ml-4 -mt-4 text-blue-500 text-xl  ">
                Discover the in-depth guide to Adopt DevOps in your organization
                effectively.{" "}
              </p>
            </details>
            <details className="w-full border rounded-lg">
              <summary className="px-4 py-6 font-bold lg:text-4xl focus:outline-none focus-visible:ri">
                Top Adoption Challenges and How to overcome them ?
              </summary>
              <p className="px-4 py-6 pt-10 ml-4 -mt-4   text-blue-500 text-xl">
                A detailed walkthrough of DevOps Adoption Challenges and how to
                easily overcome them.
              </p>
            </details>
          </div>
        </div>
      </section>
    </>
  );
}
